import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import styles from '../styles/Login.module.css';

const Login: React.FC = () => {
  const [username, setUsername] = useState(''); // Now configurable username via environment variable
  const [password, setPassword] = useState('');
  const [loginAttempts, setLoginAttempts] = useState(0);
  const { login, isLoading, error } = useAuth();

  // Add rate limiting for login attempts
  useEffect(() => {
    if (loginAttempts >= 5) {
      // Reset attempts after 2 minutes
      const timer = setTimeout(() => {
        setLoginAttempts(0);
      }, 120000); // 2 minutes in milliseconds
      
      return () => clearTimeout(timer);
    }
  }, [loginAttempts]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Check for too many login attempts
    if (loginAttempts >= 5) {
      return; // Don't allow login attempt
    }
    
    // Increment attempt counter
    setLoginAttempts(prev => prev + 1);
    
    await login(username, password);
    // Error state is handled in the AuthContext
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <h2>Drone Calculator Login</h2>
        {error && <p className={styles.error}>{error}</p>}
        {loginAttempts >= 5 && (
          <p className={styles.error}>
            Too many login attempts. Please wait 2 minutes before trying again.
          </p>
        )}
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
            <small>Enter your username</small>
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          <button 
            type="submit" 
            className={styles.loginButton} 
            disabled={isLoading || loginAttempts >= 5}
          >
            {isLoading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
